<template>
  <PosterEditor />
</template>

<script>
import PosterEditor from './components/PosterEditor.vue'

export default {
  name: 'App',
  components: {
    PosterEditor
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white;
}
</style>
